import { render, staticRenderFns } from "./DailyNumberDisplayer.vue?vue&type=template&id=4ff0c89f&scoped=true"
import script from "./DailyNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./DailyNumberDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./DailyNumberDisplayer.vue?vue&type=style&index=0&id=4ff0c89f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0c89f",
  null
  
)

export default component.exports